import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Logo from "./Logo";

type HeaderProps = {
    backLink?: {
        link: string;
        text: string;
    };
}

const Header = (props: HeaderProps) => {
    const { backLink = null } = props;

    return (
        <div className="row pt-lg-4 mb-lg-3">
            {backLink && (
                <div className="col-lg-6 d-flex justify-content-start no-print">
                    <Link className="text-decoration-none" to={backLink.link} style={{ fontSize: 18 }}>
                        <FontAwesomeIcon icon={["far", "chevron-left"]} size="sm" className="me-1" /> {backLink.text}
                    </Link>
                </div>
            )}
            <div className="ms-auto col-lg-3 d-none d-lg-inline-block header-logo">
                <Logo />
            </div>
        </div>
    )
}

export default Header;